<template>
  <v-card color="#f0f8f6" class="overflow-hidden rounded-xl">
    <div class="text-right ma-3">
      <v-btn icon @click="$emit('cancel')">
        <v-icon large>mdi-close</v-icon>
      </v-btn>
    </div>
    <v-row justify="center" align="center" class="pb-5">
      <v-col cols="16" class="text-center text-h4">
        <div>Создать аккаунт</div>
      </v-col>
    </v-row>
    <v-card-text>
      <v-card elevation="0" class="rounded-xl pa-5">
        <v-text-field
          v-model="email"
          :rules="emailRules"
          type="email"
          name="email"
          label="E-Mail"
          counter
        ></v-text-field>
        <v-text-field
          v-model="password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="passwordRules"
          :type="showPassword ? 'text' : 'password'"
          name="password"
          label="Пароль"
          counter
          @click:append="showPassword = !showPassword"
        ></v-text-field>
        <v-text-field
          v-model="repeatedPassword"
          :append-icon="showRepeatedPassword ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="passwordRules"
          :type="showRepeatedPassword ? 'text' : 'password'"
          name="repeated-password"
          label="Повторите пароль"
          counter
          @click:append="showRepeatedPassword = !showRepeatedPassword"
        ></v-text-field>
        <v-card-text class="text-center pa-2">
          <div
            class="text-body-5 red--text"
            v-if="password && repeatedPassword && password !== repeatedPassword"
          >
            Пароли не совпадают
          </div>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            class="white--text"
            style="
              background-color: #d86568;
              width: 150px;
              height: 50px;
              border-radius: 50px;
            "
            :disabled="!canSave"
            @click="createAccount"
          >
            Создать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CreateAccountForm",
  data() {
    return {
      email: "",
      password: "",
      repeatedPassword: "",
      showPassword: false,
      showRepeatedPassword: false,
      emailRules: [
        (v) => (!!v && !v.includes(" ")) || "Обязательное поле без пробелов",
        (v) => /.+@.+\..+/.test(v) || "Пример: abc@de.fg",
      ],
      passwordRules: [
        (v) => !!v || "Обязательное поле",
        (v) =>
          /^(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[\W_]).{8,}$/.test(v) ||
          "Минимум 8 символов, цифры, буквы, знаки",
        (v) => !v || !v.includes(" ") || "Пробелы запрещены",
      ],
    };
  },
  methods: {
    createAccount() {
      this.$emit("confirm", { email: this.email, password: this.password });
    },
  },
  computed: {
    canSave() {
      const emailValid = this.emailRules.every(
        (rule) => rule(this.email) === true
      );
      const passwordValid = this.passwordRules.every(
        (rule) => rule(this.password) === true
      );
      const repeatedPasswordValid = this.passwordRules.every(
        (rule) => rule(this.repeatedPassword) === true
      );
      const passwordsMatch = this.password === this.repeatedPassword;

      return (
        emailValid && passwordValid && repeatedPasswordValid && passwordsMatch
      );
    },
  },
};
</script>
